import React, { Component } from 'react';
import $ from 'jquery';
import SlidingPanels from '../components/SlidingPanels';
import ServiceTile from '../components/ServiceTile';

require('jquery.scrollto');

export default class Home extends Component {
    componentDidMount() {
        document.title = `C&A Assembly & Installation Solution`;

        this.props.clearSlides();
        $.get('/data/slides/home.json').done(data => {
            for (let i = 0, len = data.length; i < len; i++) {
                this.props.addSlide(data[i]);
            }
        });

        $(window).scrollTo(0, '0.5s');
    }

    renderService = (service, i) => {
        return (
            <li className="services-list--item" key={i}>
                <ServiceTile {...this.props} service={service} />
            </li>
        )
    }

    get leadText() {
        const { content } = this.props;

        if (Object.keys(content).length) {
            return content.pages.home.lead;
        }
        return '';
    }

    render() {
        const { services } = this.props;

        return (
            <div>
                <h1 className="vh">C&amp;A Assembly &amp; Installation Solution</h1>
                <SlidingPanels {...this.props} />

                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">

                            <p className="lead text-center" dangerouslySetInnerHTML={{ __html: this.leadText }}>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12 col-md-8 col-md-offset-2">
                            <div className="embed-responsive embed-responsive-16by9">
                                <iframe className="embed-responsive-item" src="https://www.youtube-nocookie.com/embed/CHTIrh-b6Xg?rel=0" data-frameborder="0" data-allow="encrypted-media" data-allowfullscreen title="IKEA Pax wardrobe system assembly and installation"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="services">
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12">
                                <h2 className="text-center heading">Our <strong>Services</strong></h2><br />
                            </div>
                        </div>
                        <div className="row">
                            <ul className="services-list">
                                {services.map(this.renderService)}
                            </ul>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/Home.js